import ImageLoader, { type IImageLoader } from "@Components/ImageLoader";
import { Link } from "@Components/Link";

import { DiscountCouponBase, DiscountCouponType, type IDiscountCouponBase } from "./DiscountCouponBase";

import * as css from "./DiscountCouponMobileOnly.module.css";

export interface IDiscountCouponMobileOnly extends IDiscountCouponBase {
    googleStoreImage: IImageLoader;
    googleStoreUrl: string;
    appleStoreImage: IImageLoader;
    appleStoreUrl: string;
}

export class DiscountCouponMobileOnly extends DiscountCouponBase<IDiscountCouponMobileOnly> {
    protected couponType = DiscountCouponType.MobileOnly;

    public render() {
        return (
            <div {...this.rootDefaultAttributes(css.discountCouponMobileOnly)}>
                <div className={css.descriptionSection}>
                    <div className={css.title}>{this.props.title}</div>
                    <div className={css.descriptionText}>{this.props.description}</div>
                </div>
                <div className={css.mobileApps}>
                    <div className={css.mobileAppLink}>
                        <Link navigateUrl={this.props.appleStoreUrl} target={1} hideMainLoading={true}>
                            <ImageLoader {...this.props.appleStoreImage} />
                        </Link>
                    </div>
                    <div className={css.separator} />
                    <div className={css.mobileAppLink}>
                        <Link navigateUrl={this.props.googleStoreUrl} target={1} hideMainLoading={true}>
                            <ImageLoader {...this.props.googleStoreImage} />
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    protected renderCoupon: () => JSX.Element = () => null;
}
